import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface AvailableProgressiveBonusOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlProgressiveBonusDetail: string;
    urlAssignBonus: string;
}

var COLUMNS_INDEX = {
    BonusId: 0,
    BonusName: 1
}

export class AvailableProgressiveBonusPage extends PageBase<AvailableProgressiveBonusOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;
    private _formId: string;
    private _form: JQuery;
    private _filterBonusId: JQuery;
    private _filterBonusName: JQuery;

    constructor(options: AvailableProgressiveBonusOptions) {
        super(options);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        var getBonusDetailUrl = (rowData: any): string => (`${options.urlProgressiveBonusDetail}/${rowData.BonusId}`);
        var getAssignBonusUrl = (rowData: any): string => (`${options.urlAssignBonus}&bonusId=${rowData.BonusId}`);

        this._tableId = "tableAvailableBonuses";
        this._formId = "formAvailableBonuses";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'BonusId',
            autoWidth: true,
            columns: [
                {
                    data: 'BonusId'
                },
                {
                    data: "BonusName",
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a href='${getBonusDetailUrl(rowData)}'>${data}</a>`);
                    }
                },
                {
                    data: "Created",
                    render: (data: any, type: any, rowData: any) => {
                        return (DateUtils.toDefaultWithTime(data));
                    }
                },
                {
                    data: "BonusStatus",
                },
                {
                    data: "Currencies",
                },
                {
                    sortable: false,
                    orderable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a class="assignBonusLink" data-id="${rowData.BonusId}" data-name="${rowData.BonusName}" href=${getAssignBonusUrl(rowData)}>Assign</a>`);
                    }
                },
            ],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    public assignBonus(e: any): void {
        e.preventDefault();
        this.openDialog();
    }

    private openDialog() {
        document.getElementById("areYouSureConfirmation").hidden = false;
    }
    private closeDialog() {
        document.getElementById("areYouSureConfirmation").hidden = true;
    }

    init(): void {
        this._form = Utils.getJQueryById(this._formId);
        this._form.on('submit', this.formSubmit);
        let btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        btnCancelSearch.on('click', this.cancelSearch);
        this._filterBonusId = Utils.getJQueryById('filterBonusId');
        this._filterBonusName = Utils.getJQueryById('filterBonusName');
        this._table = new Datatable(this._tableId, this._tableOptions);

        let that = this;
        var confirmButton = <HTMLButtonElement>document.getElementById("btnConfirm");
        var closeButton = <HTMLButtonElement>document.getElementById("btnHideConfirmation");
        let assignBonusLink: string;
        $(document).on('click', '.assignBonusLink', function (e) {
            let bonusNameAndId = e.target.attributes['data-name'].value + ' (' + e.target.attributes['data-id'].value + ')';
            $("#bonus-name-confirmation").text(bonusNameAndId);
            assignBonusLink = e.target.attributes['href'].value;
            that.assignBonus(e);
        });

        confirmButton.onclick = () => {
            window.location.href = assignBonusLink;
        };

        closeButton.onclick = () => this.closeDialog();
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterBonusId.val('');
        this._filterBonusName.val('');
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterBonusId = this._filterBonusId.val();
        datatable.columns(COLUMNS_INDEX.BonusId).search(filterBonusId);

        var filterBonusName = this._filterBonusName.val();
        datatable.columns(COLUMNS_INDEX.BonusName).search(filterBonusName);
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/AvailableProgressiveBonusPage.ts
 **/